import { render, staticRenderFns } from "./ConfirmationDialogShareTemplate.vue?vue&type=template&id=968a4a86"
import script from "./ConfirmationDialogShareTemplate.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogShareTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports